module.exports = __webpack_public_path__ + "img/line_paytable.16e6d1f6.png";